<template>
  <div class="InfoList">

    <template v-if="list.length != 0">
      <ul class="list">
        <mu-load-more :loaded-all="loadall" :loading="loading" @load="load">
          <li @click="add(item.id)" v-for="item in list" :key="item.id" >
            <div class="list_left">
              <p class="list_left_top">就诊人</p>
              <h2>{{ item.patientName }}</h2>
              <p class="list_left_gender">{{ ( item.gender === 0 ? "女": "男" ) }}</p>
            </div>
            <div class="list_right">
              <mu-badge v-if="item.relationship == 0" content="本人" color="primary"></mu-badge>
              <div class="list_right_li" v-else>
              <span>
                <p>与</p>
                <p>本</p>
                <p>人</p>
                <p>关</p>
                <p>系</p>
              </span>
                <p class="list_right_li_p">{{ item.relationshipName }}</p>
              </div>
              <div class="list_right_li">
            <span>
              <p>手</p>
              <p>机</p>
              <p>号</p>
            </span>
                <p class="list_right_li_p">{{ item.phoneNo }}</p>
              </div>
              <div class="list_right_li">
            <span>
              <p>身</p>
              <p>份</p>
              <p>证</p>
              <p>号</p>
            </span>
                <p class="list_right_li_p">{{ item.idCardNo }}</p>
              </div>
            </div>
          </li>
        </mu-load-more>
      </ul>
    </template>

    <template v-else>
      <NoList>
        <template #text>
          <p>暂无就诊人信息</p>
        </template>
      </NoList>
    </template>

    <div class="footer" @click="add()">
        添加就诊人信息
    </div>

  </div>
</template>

<script>
export default {
  name: "InfoList",
  data() {
    return{
      list: [],
      // 底部加载
      loadall: true,
      loading: false,
    }
  },
  created() {
    this.$isIos();

    // if(this.$store.state.token) {
      this.get_info();
    // }else {
    //   this.$auth();
    // }

  },
  mounted() {

  },
  methods: {
    load() {

    },
    get_info() {
      this.$get("patient/page")
        .then(res => {
          if(res) {
            console.log(res);
            this.loading= false;
            // res.data.list.forEach((item)=> {
            //   this.list.push(item);
            // })
            this.list= res.data;
          }
        })
    },
    add(e) {
      this.$router.push({
        path: "/InfoEdit",
        query: ( e ? {
          id: e
        } : {} )
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../../style/My/Info/InfoList";
</style>
